import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const EMAILJS_SERVICE  = 'service_0jia24m';
const EMAILJS_TEMPLATE = 'template_va2wn68';
const EMAILJS_KEY      = 'SpCTyhB53am0B5sAU';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', interest: '', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    const subject = `Contact Message — ${form.name} [${form.interest || 'General'}]`;
    const message = [
      `CONTACT MESSAGE`,
      ``,
      `━━━ SENDER ━━━`,
      `Name    : ${form.name}`,
      `Email   : ${form.email}`,
      `Phone   : ${form.phone || 'N/A'}`,
      `Topic   : ${form.interest || 'General'}`,
      ``,
      `━━━ MESSAGE ━━━`,
      form.message,
    ].join('\n');

    try {
      await emailjs.send(EMAILJS_SERVICE, EMAILJS_TEMPLATE, { subject, message }, EMAILJS_KEY);
      setSent(true);
    } catch (err) {
      setError('Failed to send. Please try WhatsApp or email us directly.');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">Get In Touch</div>
          <h1>Contact Us</h1>
          <p>We usually reply within a few minutes via WhatsApp</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container contact-layout">

          <div className="contact-form-col">
            <h2 className="contact-section-title">Send Us a Message</h2>
            {sent ? (
              <div className="contact-success">
                <div className="contact-success__icon">✓</div>
                <h3>Message sent!</h3>
                <p>We'll get back to you within 24 hours. For faster replies, use WhatsApp below.</p>
                <a
                  href="https://wa.me/212694401220"
                  target="_blank" rel="noreferrer"
                  className="btn btn-primary"
                  style={{ marginTop: 16, background: '#25d366', display: 'inline-flex' }}
                >
                  Open WhatsApp
                </a>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-field">
                    <label>Full Name *</label>
                    <input type="text" placeholder="Your name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
                  </div>
                  <div className="form-field">
                    <label>Email *</label>
                    <input type="email" placeholder="your@email.com" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label>Phone / WhatsApp</label>
                    <input type="tel" placeholder="+1 234 567 890" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
                  </div>
                  <div className="form-field">
                    <label>I'm interested in</label>
                    <select value={form.interest} onChange={e => setForm({ ...form, interest: e.target.value })}>
                      <option value="">Select a topic</option>
                      <option>Atlas Mountains Day Trip</option>
                      <option>Agafay Desert Tour</option>
                      <option>Hot Air Balloon</option>
                      <option>Private Tour</option>
                      <option>Group Booking</option>
                      <option>Other</option>
                    </select>
                  </div>
                </div>
                <div className="form-field">
                  <label>Message *</label>
                  <textarea placeholder="Tell us about your travel dates, group size, and any questions you have..." required rows={5} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} />
                </div>

                {error && (
                  <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '12px 16px', fontSize: 13, color: '#991b1b', marginBottom: 12 }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ padding: '14px 32px', fontSize: 15 }}
                  disabled={sending}
                >
                  {sending ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>

          <div className="contact-info-col">
            <h2 className="contact-section-title">Contact Details</h2>

            <div className="contact-info-list">
              <div className="contact-info-item">
                <div className="contact-info-icon">📞</div>
                <div>
                  <div className="contact-info-label">Phone</div>
                  <a href="tel:+212694401220" className="contact-info-value">+212 694 401 220</a>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">💬</div>
                <div>
                  <div className="contact-info-label">WhatsApp (fastest reply)</div>
                  <a href="https://wa.me/212694401220" target="_blank" rel="noreferrer" className="contact-info-value" style={{ color: '#25d366' }}>
                    +212 694 401 220
                  </a>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">✉</div>
                <div>
                  <div className="contact-info-label">Email</div>
                  <a href="mailto:marrakechbestactivities@gmail.com" className="contact-info-value">marrakechbestactivities@gmail.com</a>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">📍</div>
                <div>
                  <div className="contact-info-label">Office</div>
                  <span className="contact-info-value">Askejour Res Raha Imm 11 Apt 37 Marrakech — Hamza Jillali</span>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">🕐</div>
                <div>
                  <div className="contact-info-label">Office Hours</div>
                  <span className="contact-info-value">Mon–Sun · 08:00 – 20:00 (GMT+1)</span>
                </div>
              </div>
            </div>

            <div className="contact-wa-box">
              <div style={{ fontSize: 28 }}>💬</div>
              <div>
                <div style={{ fontWeight: 500, color: 'var(--dark-2)', marginBottom: 4 }}>Prefer WhatsApp?</div>
                <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>Most guests book and get answers in under 5 minutes via WhatsApp.</p>
                <a
                  href="https://wa.me/212694401220?text=Hello!%20I%27d%20like%20to%20book%20a%20tour."
                  target="_blank" rel="noreferrer"
                  className="btn btn-sm"
                  style={{ background: '#25d366', color: '#fff', textDecoration: 'none' }}
                >
                  Chat on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
